<div class="upsell-product-box">
  <div class="upsell-product-box__container justify-center mx-auto w-full p-8">
    <div class="upsell-product-box__wrapper">
      
      <div *ngIf="showTitle" class="upsell-product-box__title"><div [innerHTML]="title"></div></div>
      
      <div class="upsell-product-box__content flex flex-col items-center desktop:flex-row gap-6">
        
        <div class="upsell-product-box__image-wrapper w-full mx-auto flex flex-col justify-center desktop:flex-shrink-0">
          <img class="upsell-product-box__image max-h-80 self-center" src="{{ image }}" alt="{{ imageAlt }}">
        <img *ngIf="auxImg" class="upsell-product-box__aux-image w-full h-auto mt-2" src="{{ auxImg }}"  alt="{{ auxImgAlt }}">
      </div>
        
        <div class="upsell-product-box__description w-full text-center" [ngClass]="{'hasTitle': showTitle}">
          <p class="upsell-product-box__subtitle text-3xl mb-4" [innerHTML]="subTitle"></p>
          
          <div class="upsell-product-box__pricing text-xl placeholder:space-y-2">
            <p class="upsell-product-box__regularPrice notranslate">
              <span class="upsell-product-box__regularPrice-text">{{regularText}}: </span> 
              <span class="upsell-product-box__regularPrice-number">{{ regularPrice | dynamicCurrency:currency }}</span>
            </p>
            
            <p class="upsell-product-box__instantSavings text-xl font-bold notranslate">
              <span class="upsell-product-box__instantSavings-text">{{instantSavingsText}}: </span> 
              <span class="upsell-product-box__instantSavings-number">{{ instantSavings | dynamicCurrency:currency }}</span>
            </p>
            
            <p class="upsell-product-box__yourPrice text-2xl pt-5 notranslate">
              <span class="upsell-product-box__yourPrice-text">{{yourPriceText}}: </span>
              <span class="upsell-product-box__yourPrice-number">{{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
